import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { GateWay } from '../gateway.model';

export enum GateWayProfileActionTypes {
  UpsertProfileList = '[GateWay] Upsert Profile List',
  ReadProfileList = '[GateWay] Read Profile List',
  ReadProfileListFail = '[GateWay] Read Profile List Fail',
  UpsertProfileInfo = '[GateWay] Upsert Profile Info',
  ReadProfileInfo = '[GateWay] Read Profile Info',
  ReadProfileInfoFail = '[GateWay] Read Profile Info Fail',
  AddProfileInfo = '[GateWay] Add Profile Info',
  UpdateProfileInfo = '[GateWay] Update Profile Info',
  DeleteProfileInfo = '[GateWay] Delete Profile Info',
}

export class ReadProfileList implements Action {
  readonly type = GateWayProfileActionTypes.ReadProfileList;

  constructor(public payload: any = null) {}
}
export class UpsertProfileList implements Action {
  readonly type = GateWayProfileActionTypes.UpsertProfileList;

  constructor(public payload: any) {}
}
export class ReadProfileListFail implements Action {
  readonly type = GateWayProfileActionTypes.ReadProfileListFail;

  constructor(public payload: any = null) {}
}
export class ReadProfileInfo implements Action {
  readonly type = GateWayProfileActionTypes.ReadProfileInfo;

  constructor(public payload: any = null) {}
}
export class UpsertProfileInfo implements Action {
  readonly type = GateWayProfileActionTypes.UpsertProfileInfo;

  constructor(public payload: any = null) {}
}
export class ReadProfileInfoFail implements Action {
  readonly type = GateWayProfileActionTypes.ReadProfileInfoFail;

  constructor(public payload: any = null) {}
}

export class AddProfileInfo implements Action {
  readonly type = GateWayProfileActionTypes.AddProfileInfo;

  constructor(public payload: any = null) {}
}
export class UpdateProfileInfo implements Action {
  readonly type = GateWayProfileActionTypes.UpdateProfileInfo;

  constructor(public payload: any = null) {}
}
export class DeleteProfileInfo implements Action {
  readonly type = GateWayProfileActionTypes.DeleteProfileInfo;

  constructor(public payload: any = null) {}
}


export type GateWayProfileActions =
ReadProfileList
 | UpsertProfileList
 | ReadProfileListFail
 | ReadProfileInfo
 | UpsertProfileInfo
 | ReadProfileInfoFail
 | AddProfileInfo
 | UpdateProfileInfo
 | DeleteProfileInfo
